import { AgricultureMapConstants, LAYER_TYPES, LOCATIONS_ZOOM_RANGE } from "src/app/main/constants/dims-map-constants";

export const LOCATION_HIE: any = ['COUNTRY', 'STATE', 'DISTRICT', 'BLOCK'];

// Urban Heat Island is scoped to a single city (Gurugram). The sidebar's generic
// location-hierarchy params (pUUID/pEUUID) come from the logged-in user's own
// home location (often COUNTRY-level), not this module's fixed district — so the
// district identity is hardcoded here rather than trusted from queryParams.
export const GURUGRAM_DISTRICT_UUID: string = 'd7cf71c9-b149-49b9-8cd7-94641096d67f';
export const GURUGRAM_DISTRICT_NAME: string = 'GURGAON';

export const URBAN_HEAT_ISLAND_LEGEND_LIST: any = {
  [AgricultureMapConstants.LOCATIONS.INDIA]: {
    URBAN_HEAT_ISLAND_LEGEND: {
      colorValues: [
        { backgroundColor: '#ffffb2', text: 'Low', textColor: '#000000' },
        { backgroundColor: '#fd8d3c', text: 'Moderate', textColor: '#000000' },
        { backgroundColor: '#bd0026', text: 'High', textColor: '#ffffff' }
      ]
    },
    // One legend entry per correlation raster (NDVI/NDBI/LST/LULC) — keyed as `${type}_LEGEND`
    // so UrbanHeatIslandMapService.updateLegendForType() can look each one up directly off the
    // sidebar's selected type, matching the shared gis-dims-map legend control's
    // {Units, colorValues:[{backgroundColor, text, textColor}]} input shape.
    NDVI_LEGEND: {
      Units: 'NDVI',
      colorValues: [
        { backgroundColor: '#4575B4', text: '-0.09 – 0.00', textColor: '#ffffff', tooltip: 'Water/bare' },
        { backgroundColor: '#D9EF8B', text: '0.00 – 0.10', textColor: '#000000', tooltip: 'Barren land' },
        { backgroundColor: '#BFE34A', text: '0.10 – 0.20', textColor: '#000000', tooltip: 'Sparse veg' },
        { backgroundColor: '#7FCB2A', text: '0.20 – 0.30', textColor: '#000000', tooltip: 'Low veg' },
        { backgroundColor: '#3DA64A', text: '0.30 – 0.40', textColor: '#ffffff', tooltip: 'Moderate veg' },
        { backgroundColor: '#238B45', text: '0.40 – 0.55', textColor: '#ffffff', tooltip: 'Dense veg' },
        { backgroundColor: '#145A20', text: '> 0.55', textColor: '#ffffff', tooltip: 'Very dense veg' }
      ]
    },
    NDBI_LEGEND: {
      Units: 'NDBI',
      colorValues: [
        { backgroundColor: '#4575B4', text: '-0.39 – -0.28', textColor: '#ffffff', tooltip: 'Water body' },
        { backgroundColor: '#BFE34A', text: '-0.28 – -0.18', textColor: '#000000', tooltip: 'Dense vegetation' },
        { backgroundColor: '#D9EF8B', text: '-0.18 – -0.07', textColor: '#000000', tooltip: 'Sparse vegetation' },
        { backgroundColor: '#F9A825', text: '-0.07 – 0.02', textColor: '#000000', tooltip: 'Mixed/open land' },
        { backgroundColor: '#F4511E', text: '0.02 – 0.12', textColor: '#ffffff', tooltip: 'Built-up' },
        { backgroundColor: '#E31A1C', text: '0.12 – 0.23', textColor: '#ffffff', tooltip: 'Dense built-up' },
        { backgroundColor: '#990000', text: '> 0.23', textColor: '#ffffff', tooltip: 'Highly built-up' }
      ]
    },
    // LST_LEGEND: {
    //   Units: 'Land Surface Temperature (°C)',
    //   colorValues: [
    //     { backgroundColor: '#87CEEB', text: 'Below 23.60', textColor: '#000000' },
    //     { backgroundColor: '#006837', text: '23.60 – 34.90', textColor: '#ffffff' },
    //     { backgroundColor: '#66A61E', text: '34.90 – 38.71', textColor: '#000000' },
    //     { backgroundColor: '#FFD92F', text: '38.71 – 41.72', textColor: '#000000' },
    //     { backgroundColor: '#F7931E', text: '41.72 – 44.49', textColor: '#000000' },
    //     { backgroundColor: '#EF2B2D', text: '44.49 – 53.16', textColor: '#ffffff' }
    //   ]
    // },
    LST_LEGEND: {
  Units: 'Land Surface Temperature (°C)',
  colorValues: [
    {
      backgroundColor: '#4A90E2',
      text: '0 – 25',
      textColor: '#000000',
      tooltip: 'Cool zone'
    },
    {
      backgroundColor: '#2ECC71',
      text: '25 – 30',
      textColor: '#000000',
      tooltip: 'Mild'
    },
    {
      backgroundColor: '#FFD700',
      text: '30 – 35',
      textColor: '#000000',
      tooltip: 'Warm'
    },
    {
      backgroundColor: '#FFA500',
      text: '35 – 40',
      textColor: '#000000',
      tooltip: 'Hot'
    },
    {
      backgroundColor: '#E67E22',
      text: '40 – 45',
      textColor: '#ffffff',
      tooltip: 'Very hot'
    },
    {
      backgroundColor: '#E74C3C',
      text: '45 – 50',
      textColor: '#ffffff',
      tooltip: 'Extreme heat'
    },
    {
      backgroundColor: '#C0392B',
      text: '50 and above',
      textColor: '#ffffff',
      tooltip: 'Heat hotspot'
    }
  ]
},

    // LULC shows only class names (no numeric raster codes) per the ticket's display requirement.
    LULC_LEGEND: {
      Units: 'Land Use / Land Cover Class',
      colorValues: [
        { backgroundColor: '#419BDF', text: 'Water', textColor: '#ffffff' },
        { backgroundColor: '#397D49', text: 'Trees', textColor: '#ffffff' },
        { backgroundColor: '#7A87C6', text: 'Flooded Vegetation', textColor: '#ffffff' },
        { backgroundColor: '#E49635', text: 'Crops', textColor: '#000000' },
        { backgroundColor: '#C4281B', text: 'Built Area', textColor: '#ffffff' },
        { backgroundColor: '#A59B8F', text: 'Bare Ground', textColor: '#000000' },
        { backgroundColor: '#A8EBFF', text: 'Snow/Ice', textColor: '#000000' },
        { backgroundColor: '#616161', text: 'Clouds', textColor: '#ffffff' },
        { backgroundColor: '#E3E2C3', text: 'Rangeland', textColor: '#000000' }
      ]
    },
    MNDWI_LEGEND: {
      Units: 'MNDWI',
      colorValues: [
        { backgroundColor: '#8c510a', text: '-0.60 – -0.35', textColor: '#ffffff', tooltip: 'Dry/built-up' },
        { backgroundColor: '#d8b365', text: '-0.35 – -0.10', textColor: '#000000', tooltip: 'Dry land' },
        { backgroundColor: '#f6e8c3', text: '-0.10 – 0.10', textColor: '#000000', tooltip: 'Slight moisture' },
        { backgroundColor: '#c7eae5', text: '0.10 – 0.30', textColor: '#000000', tooltip: 'Moist soil' },
        { backgroundColor: '#80cdc1', text: '0.30 – 0.55', textColor: '#000000', tooltip: 'Wet surface' },
        { backgroundColor: '#35978f', text: '0.55 – 0.80', textColor: '#ffffff', tooltip: 'Shallow water' },
        { backgroundColor: '#01665e', text: '> 0.80', textColor: '#ffffff', tooltip: 'Open water' }
      ]
    },
    MODIS_LST_DAY_LEGEND: {
      Units: '°C',
      colorValues: [
        { backgroundColor: '#001B95', text: '0 – 5', textColor: '#ffffff' },
        { backgroundColor: '#0C41BB', text: '5 – 10', textColor: '#ffffff' },
        { backgroundColor: '#1265A9', text: '10 – 15', textColor: '#ffffff' },
        { backgroundColor: '#188E93', text: '15 – 20', textColor: '#ffffff' },
        { backgroundColor: '#81BA63', text: '20 – 25', textColor: '#000000' },
        { backgroundColor: '#CCC24F', text: '25 – 30', textColor: '#000000' },
        { backgroundColor: '#FFBB38', text: '30 – 35', textColor: '#000000' },
        { backgroundColor: '#FF9E20', text: '35 – 40', textColor: '#000000' },
        { backgroundColor: '#FF800E', text: '40 – 45', textColor: '#000000' },
        { backgroundColor: '#FD5F0D', text: '45 – 50', textColor: '#ffffff' },
        { backgroundColor: '#FF3F0A', text: '50 – 55', textColor: '#ffffff' },
        { backgroundColor: '#DF2108', text: '55 – 60', textColor: '#ffffff' },
        { backgroundColor: '#AD1919', text: '> 60', textColor: '#ffffff' }
      ]
    },
    MODIS_LST_NIGHT_LEGEND: {
      Units: '°C',
      colorValues: [
        { backgroundColor: '#00167B', text: '< 0', textColor: '#ffffff' },
        { backgroundColor: '#001B95', text: '0 – 5', textColor: '#ffffff' },
        { backgroundColor: '#0C41BB', text: '5 – 10', textColor: '#ffffff' },
        { backgroundColor: '#1265A9', text: '10 – 15', textColor: '#ffffff' },
        { backgroundColor: '#188E93', text: '15 – 20', textColor: '#ffffff' },
        { backgroundColor: '#81BA63', text: '20 – 25', textColor: '#000000' },
        { backgroundColor: '#CCC24F', text: '25 – 30', textColor: '#000000' },
        { backgroundColor: '#FFBB38', text: '30 – 35', textColor: '#000000' },
        { backgroundColor: '#FF9E20', text: '35 – 40', textColor: '#000000' },
        { backgroundColor: '#FF800E', text: '40 – 45', textColor: '#000000' },
        { backgroundColor: '#FD5F0D', text: '45 – 50', textColor: '#ffffff' },
        { backgroundColor: '#FF3F0A', text: '50 – 55', textColor: '#ffffff' },
        { backgroundColor: '#DF2108', text: '55 – 60', textColor: '#ffffff' },
        { backgroundColor: '#AD1919', text: '> 60', textColor: '#ffffff' }
      ]
    },
    APPARENT_TEMP_LEGEND: {
      Units: 'Apparent Temperature (°C)',
      colorValues: [
        { backgroundColor: '#313695', text: '< 20 °C', textColor: '#ffffff' },
        { backgroundColor: '#4575b4', text: '20 - 25 °C', textColor: '#ffffff' },
        { backgroundColor: '#74add1', text: '25 - 30 °C', textColor: '#000000' },
        { backgroundColor: '#abd9e9', text: '30 - 32 °C', textColor: '#000000' },
        { backgroundColor: '#fee090', text: '32 - 34 °C', textColor: '#000000' },
        { backgroundColor: '#fdae61', text: '34 - 36 °C', textColor: '#000000' },
        { backgroundColor: '#f46d43', text: '36 - 38 °C', textColor: '#ffffff' },
        { backgroundColor: '#d73027', text: '> 38 °C', textColor: '#ffffff' }
      ]
    },
    AUHI_DAY_LEGEND: {
      Units: 'AUHI Day (°C)',
      colorValues: [
        { backgroundColor: '#4575b4', text: '< -0.50 °C', textColor: '#ffffff' },
        { backgroundColor: '#91bfdb', text: '-0.50 to -0.30 °C', textColor: '#000000' },
        { backgroundColor: '#e0f3f8', text: '-0.30 to -0.10 °C', textColor: '#000000' },
        { backgroundColor: '#ffffbf', text: '-0.10 to 0 °C', textColor: '#000000' },
        { backgroundColor: '#fee090', text: '0 to 0.05 °C', textColor: '#000000' },
        { backgroundColor: '#fc8d59', text: '0.05 to 0.10 °C', textColor: '#000000' },
        { backgroundColor: '#d73027', text: '> 0.10 °C', textColor: '#ffffff' }
      ]
    },
    AUHI_NIGHT_LEGEND: {
      Units: 'AUHI Night (°C)',
      colorValues: [
        { backgroundColor: '#4575b4', text: '< -0.50 °C', textColor: '#ffffff' },
        { backgroundColor: '#91bfdb', text: '-0.50 to -0.30 °C', textColor: '#000000' },
        { backgroundColor: '#e0f3f8', text: '-0.30 to -0.10 °C', textColor: '#000000' },
        { backgroundColor: '#ffffbf', text: '-0.10 to 0 °C', textColor: '#000000' },
        { backgroundColor: '#fee090', text: '0 to 0.05 °C', textColor: '#000000' },
        { backgroundColor: '#fc8d59', text: '0.05 to 0.10 °C', textColor: '#000000' },
        { backgroundColor: '#d73027', text: '> 0.10 °C', textColor: '#ffffff' }
      ]
    },
    HEAT_INDEX_LEGEND: {
      Units: 'Heat Index (°C)',
      colorValues: [
        { backgroundColor: '#313695', text: '< 28 °C', textColor: '#ffffff' },
        { backgroundColor: '#4575b4', text: '28 - 30 °C', textColor: '#ffffff' },
        { backgroundColor: '#74add1', text: '30 - 32 °C', textColor: '#000000' },
        { backgroundColor: '#abd9e9', text: '32 - 34 °C', textColor: '#000000' },
        { backgroundColor: '#fee090', text: '34 - 36 °C', textColor: '#000000' },
        { backgroundColor: '#fdae61', text: '36 - 38 °C', textColor: '#000000' },
        { backgroundColor: '#f46d43', text: '38 - 40 °C', textColor: '#ffffff' },
        { backgroundColor: '#d73027', text: '> 40 °C', textColor: '#ffffff' }
      ]
    },
    SUHI_LEGEND: {
      Units: 'SUHI (°C)',
      colorValues: [
        { backgroundColor: '#4575b4', text: '< -5 °C', textColor: '#ffffff' },
        { backgroundColor: '#91bfdb', text: '-5 to -2 °C', textColor: '#000000' },
        { backgroundColor: '#e0f3f8', text: '-2 to 0 °C', textColor: '#000000' },
        { backgroundColor: '#ffffbf', text: '0 to 0.5 °C', textColor: '#000000' },
        { backgroundColor: '#fee090', text: '0.5 to 1 °C', textColor: '#000000' },
        { backgroundColor: '#fc8d59', text: '1 to 2 °C', textColor: '#000000' },
        { backgroundColor: '#d73027', text: '> 2 °C', textColor: '#ffffff' }
      ]
    },
    TAIR_DAY_LEGEND: {
      Units: 'Tair Day (°C)',
      colorValues: [
        { backgroundColor: '#313695', text: '< 26 °C', textColor: '#ffffff' },
        { backgroundColor: '#4575b4', text: '26 - 28 °C', textColor: '#ffffff' },
        { backgroundColor: '#74add1', text: '28 - 30 °C', textColor: '#000000' },
        { backgroundColor: '#abd9e9', text: '30 - 32 °C', textColor: '#000000' },
        { backgroundColor: '#fee090', text: '32 - 34 °C', textColor: '#000000' },
        { backgroundColor: '#fdae61', text: '34 - 36 °C', textColor: '#000000' },
        { backgroundColor: '#f46d43', text: '36 - 38 °C', textColor: '#ffffff' },
        { backgroundColor: '#d73027', text: '> 38 °C', textColor: '#ffffff' }
      ]
    },
    TAIR_NIGHT_LEGEND: {
      Units: 'Tair Night (°C)',
      colorValues: [
        { backgroundColor: '#313695', text: '< 18 °C', textColor: '#ffffff' },
        { backgroundColor: '#4575b4', text: '18 - 20 °C', textColor: '#ffffff' },
        { backgroundColor: '#74add1', text: '20 - 22 °C', textColor: '#000000' },
        { backgroundColor: '#abd9e9', text: '22 - 24 °C', textColor: '#000000' },
        { backgroundColor: '#fee090', text: '24 - 26 °C', textColor: '#000000' },
        { backgroundColor: '#fdae61', text: '26 - 28 °C', textColor: '#000000' },
        { backgroundColor: '#f46d43', text: '28 - 30 °C', textColor: '#ffffff' },
        { backgroundColor: '#d73027', text: '> 30 °C', textColor: '#ffffff' }
      ]
    },
    WET_BULB_TEMP_LEGEND: {
      Units: 'Wet Bulb Temp (°C)',
      colorValues: [
        { backgroundColor: '#313695', text: '< 20 °C', textColor: '#ffffff' },
        { backgroundColor: '#4575b4', text: '20 - 21 °C', textColor: '#ffffff' },
        { backgroundColor: '#74add1', text: '21 - 22 °C', textColor: '#000000' },
        { backgroundColor: '#abd9e9', text: '22 - 23 °C', textColor: '#000000' },
        { backgroundColor: '#fee090', text: '23 - 24 °C', textColor: '#000000' },
        { backgroundColor: '#fdae61', text: '24 - 25 °C', textColor: '#000000' },
        { backgroundColor: '#f46d43', text: '25 - 26 °C', textColor: '#ffffff' },
        { backgroundColor: '#d73027', text: '> 26 °C', textColor: '#ffffff' }
      ]
    }
  }
};

// All 17 header-pill layers, in display order. Any one of these can occupy any of the
// PANEL_COUNT fixed grid slots — panel position never changes, only which layer (if any)
// currently occupies it. `icon` (FontAwesome 5 class) and `slug` (kebab-case, used for the
// pill's/panel's CSS modifier class) are only consumed by the header pill selector — the map
// grid only ever reads key/label.
export const UHI_ALL_LAYERS: Array<{ key: string; label: string; icon: string; slug: string }> = [
  { key: 'NDVI', label: 'NDVI', icon: 'fa-leaf', slug: 'ndvi' },
  { key: 'NDBI', label: 'NDBI', icon: 'fa-building', slug: 'ndbi' },
  { key: 'LST', label: 'LST', icon: 'fa-thermometer-half', slug: 'lst' },
  { key: 'LULC', label: 'LULC', icon: 'fa-map', slug: 'lulc' },
  { key: 'MNDWI', label: 'MNDWI', icon: 'fa-tint', slug: 'mndwi' },
  { key: 'MODIS_LST_DAY', label: 'MODIS LST Day', icon: 'fa-sun', slug: 'modis_lst_day' },
  { key: 'MODIS_LST_NIGHT', label: 'MODIS LST Night', icon: 'fa-moon', slug: 'modis_lst_night' },
  { key: 'APPARENT_TEMP', label: 'Apparent Temp', icon: 'fa-thermometer-three-quarters', slug: 'apparent_temp_2km' },
  { key: 'AUHI_DAY', label: 'AUHI Day', icon: 'fa-city', slug: 'auhi_day_2km' },
  { key: 'AUHI_NIGHT', label: 'AUHI Night', icon: 'fa-city', slug: 'auhi_night_2km' },
  { key: 'HEAT_INDEX', label: 'Heat Index', icon: 'fa-fire', slug: 'heat_index_2km' },
  { key: 'SUHI', label: 'SUHI', icon: 'fa-satellite', slug: 'suhi_30m' },
  { key: 'TAIR_DAY', label: 'Daytime Air Temp', icon: 'fa-cloud-sun', slug: 'tair_day_2km' },
  { key: 'TAIR_NIGHT', label: 'Nighttime Air Temp', icon: 'fa-cloud-moon', slug: 'tair_night_2km' },
  { key: 'WET_BULB_TEMP', label: 'Wet Bulb Temp', icon: 'fa-water', slug: 'wet_bulb_temp_2km' },
];

// Number of fixed grid panels — this never changes; only the layer-per-slot mapping does.
export const PANEL_COUNT = 4;

// Which layer occupies each panel slot on first load, in slot order.
export const DEFAULT_PANEL_LAYER_KEYS: string[] = ['NDVI', 'NDBI', 'LST', 'LULC'];

export const URBAN_CORRELATION_LAYERS: any = {
  NDVI: 'correlation:ndvi',
  NDBI: 'correlation:ndbi',
  LST: 'correlation:lst',
  LULC: 'correlation:lulc',
  MNDWI: 'correlation:mndwi',
  MODIS_LST_DAY: 'correlation:modis_lst_day',
  MODIS_LST_NIGHT: 'correlation:modis_lst_night',
  APPARENT_TEMP: 'HeatExposureKpis:apparent_temp_2km',
  AUHI_DAY: 'HeatExposureKpis:auhi_day_2km',
  AUHI_NIGHT: 'HeatExposureKpis:auhi_night_2km',
  HEAT_INDEX: 'HeatExposureKpis:heat_index_2km',
  SUHI: 'HeatExposureKpis:suhi_30m',
  TAIR_DAY: 'HeatExposureKpis:tair_day_2km',
  TAIR_NIGHT: 'HeatExposureKpis:tair_night_2km',
  WET_BULB_TEMP: 'HeatExposureKpis:wet_bulb_temp_2km'
};

export const DEFAULT_CORRELATION_LAYER: string = 'LST';

export interface UhiOverlayLayerConfig {
  id: string;
  label: string;
  workspace: string;
  layer: string;
  // 'VECTOR' overlays are fetched as WFS GetFeature GeoJSON, scoped to the selected ward via a
  // ward_uuid CQL filter (see UrbanHeatIslandMapService.addOverlayLayer) — 'WMS' overlays render
  // the workspace:layer raster/style directly, unfiltered, exactly as before.
  layerType: 'VECTOR' | 'WMS';
  // Gurgaon (DISTRICT) level only — a 'VECTOR' overlay whose unfiltered city-wide WFS response is
  // too large to load as client-side GeoJSON (gurugram_buildings: ~107k features, ~470 MB) is
  // rendered as a WMS tile layer of the same workspace:layer instead. Ward level is unaffected.
  cityLevelLayerType?: 'WMS';
}

// Optional "Layers" dropdown overlays — none selected by default, rendered on top of the Ward
// Boundary (which is always on) via the shared 'uhiOverlay' Leaflet pane (see
// UrbanHeatIslandMapComponent.initMaps()), z-indexed above the 'depth' pane Ward Boundary uses.
// At most one of these is ever active at a time (see UrbanHeatIslandMapService.addOverlayLayer/
// removeOverlayLayer) — adding a new overlay only ever means adding another entry here; the
// dropdown, the single-active-overlay toggle logic, and the map service are all keyed off `id`
// and never reference a specific overlay by name. gurugram_waterlines is the sole WMS exception —
// every other overlay is a ward_uuid-filtered vector layer.
export const UHI_OVERLAY_LAYERS: UhiOverlayLayerConfig[] = [
  { id: 'gurugram_buildings', label: 'Gurugram Buildings', workspace: 'HEATWAVE', layer: 'gurugram_buildings', layerType: 'VECTOR', cityLevelLayerType: 'WMS' },
  { id: 'gurugram_cbds', label: 'Gurugram CBDs', workspace: 'HEATWAVE', layer: 'gurugram_cbds', layerType: 'VECTOR' },
  { id: 'gurugram_electricity_substations', label: 'Electricity Substations', workspace: 'HEATWAVE', layer: 'gurugram_electricity_substations', layerType: 'VECTOR' },
  { id: 'gurugram_hospitals', label: 'Hospitals', workspace: 'HEATWAVE', layer: 'gurugram_hospitals', layerType: 'VECTOR' },
  { id: 'gurugram_industrial_areas', label: 'Industrial Areas', workspace: 'HEATWAVE', layer: 'gurugram_industrial_areas', layerType: 'VECTOR' },
  { id: 'gurugram_markets', label: 'Markets', workspace: 'HEATWAVE', layer: 'gurugram_market', layerType: 'VECTOR' },
  { id: 'gurugram_municipal_bldgs', label: 'Municipal Buildings', workspace: 'HEATWAVE', layer: 'gurugram_municipal_bldgs', layerType: 'VECTOR' },
  { id: 'gurugram_parks', label: 'Parks', workspace: 'HEATWAVE', layer: 'gurugram_parks', layerType: 'VECTOR' },
  { id: 'gurugram_schools', label: 'Schools', workspace: 'HEATWAVE', layer: 'gurugram_schools', layerType: 'VECTOR' },
  { id: 'gurugram_water_bodies', label: 'Water Bodies', workspace: 'HEATWAVE', layer: 'gurugram_water_bodies', layerType: 'VECTOR' },
  { id: 'gurugram_waterlines', label: 'Water Lines', workspace: 'HEATWAVE', layer: 'gurugram_waterlines', layerType: 'WMS' },
  { id: 'gurugram_watersupply', label: 'Water Supply', workspace: 'HEATWAVE', layer: 'gurugram_watersupply', layerType: 'VECTOR' }
];

// Central overlay -> Utilities Exposure chart category mapping (see UTILITIES_CATEGORY_LABELS in
// urban-heat-island-infobox.cnst.ts). Selecting a ward-level "Layers" overlay auto-selects its
// matching category in the Utilities Exposure by LST Range chart dropdown (UrbanHeatIslandInfoboxComponent),
// and vice versa (see UHI_UTILITY_KEY_TO_OVERLAY below).
export const UHI_OVERLAY_TO_UTILITY_KEY: { [overlayId: string]: string } = {
  gurugram_buildings: 'buildings_footprints',
  gurugram_cbds: 'cbds_commercial',
  gurugram_electricity_substations: 'electricity_substations',
  gurugram_hospitals: 'hospitals_phcs',
  gurugram_industrial_areas: 'industrial_areas',
  gurugram_municipal_bldgs: 'municipal_buildings',
  gurugram_markets: 'public_markets',
  gurugram_parks: 'public_parks',
  gurugram_schools: 'schools',
  gurugram_water_bodies: 'water_bodies',
  gurugram_waterlines: 'water_bodies',
  gurugram_watersupply: 'water_supply_infrastructure'
};

// Reverse of UHI_OVERLAY_TO_UTILITY_KEY, derived automatically so the two mappings can never
// drift apart. Only one overlay can ever be active on the map at a time, so where more than one
// overlay shares a category ('gurugram_water_bodies' and 'gurugram_waterlines' both represent
// 'water_bodies'), the first one declared above wins as the canonical choice.
export const UHI_UTILITY_KEY_TO_OVERLAY: { [utilityKey: string]: string } = Object.keys(UHI_OVERLAY_TO_UTILITY_KEY)
  .reduce((acc: { [utilityKey: string]: string }, overlayId: string) => {
    const utilityKey = UHI_OVERLAY_TO_UTILITY_KEY[overlayId];
    if (!acc[utilityKey]) { acc[utilityKey] = overlayId; }
    return acc;
  }, {});

export const URBAN_HEAT_ISLAND_LAYER_LIST: any = {
  [AgricultureMapConstants.LOCATIONS.INDIA]: {
       'State Boundaries': {
      source: 'INDIA',
      displayName: 'State Boundaries',
      name: 'State Boundaries',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:gurugram_boundary',
      layer_name: 'State Boundaries',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      type: LAYER_TYPES.GEOJSON_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      onEachFeature: 'handleAdminPolygons',
      environment_server_url: 'COMMON_GEOSERVER_URL',
      layeroptions_protocol: 'WFS'
    },
     'Ward Boundary': {
      source: 'INDIA',
      displayName: 'Wards',
      name: 'Ward Boundary',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:gurugram_wards',
      layer_name: 'Ward Boundary',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.VECTOR_LAYER,
      type: LAYER_TYPES.VECTOR_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      crs: 'EPSG4326',
      hasLables: true,
      applycql_filter: false,
      legendName: 'URBAN_HEAT_ISLAND_LEGEND',
      layeroptions_protocol: 'WFS'
    },
      'Ward Boundaries': {
      source: 'INDIA',
      displayName: 'State Boundaries',
      name: 'State Boundaries',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:gurugram_wards',
      layer_name: 'Ward Boundaries',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      type: LAYER_TYPES.GEOJSON_LAYER,
      cql_filter_value: 'uuid',
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      onEachFeature: 'handleWardBoundaryHover',
      environment_server_url: 'COMMON_GEOSERVER_URL',
      layeroptions_protocol: 'WFS'
    },
  }
};
